import { SHOW_APP_MESSAGE } from 'use-app';

const ErrorCodeMapper = {};
export const errorHandler = error => {
  if (typeof error === 'string') {
    return error;
  }
  const { response } = error;

  if (response && response.status) {
    const { status, data } = response;
    switch (status) {
      case 400:
        return data.error;
      case 422:
        if (Array.isArray(data.errors)) {
          return data.errors[0].message;
        } else {
          return ErrorCodeMapper[data.error.code] || data.error.message;
        }
      case 500:
        return '伺服器發生錯誤';
      default:
        return error.message;
    }
  } else {
    return '發生未知錯誤';
  }
};

export const errorHandingWithCode = error => {
  const { response } = error;
  if (response && response.status) {
    const { status, data } = response;
    if (status === 422) {
      return {
        code: data.error.code,
        message: ErrorCodeMapper[data.error.code] || data.error.message,
      };
    } else {
      return {
        code: undefined,
        message: errorHandler(error),
      };
    }
  }
};

export const showAppError = (dispatch, error, errorText) => {
  dispatch({
    type: SHOW_APP_MESSAGE,
    payload: {
      type: 'failure',
      message: errorText || errorHandler(error),
    },
  });
};
